import { EditEditorRightsComponent } from './edit-editorrights/edit-editorrights.component';
import { AddEditorRightsComponent } from './add-editorrights/add-editorrights.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListEditorRightsComponent } from './list-editorrights/list-editorrights.component';

export const routesEditorRights: Routes = [
    { path: 'editorrights', component: ListEditorRightsComponent },
    { path: 'editorrights/add', component: AddEditorRightsComponent },
    { path: 'editorrights/:id/edit', component: EditEditorRightsComponent },
];

export const EditorRightsRoutes: ModuleWithProviders = RouterModule.forChild(routesEditorRights);
